export default function GrantSynopsis({ safeDescriptionHtml }) {
  if (!safeDescriptionHtml) return null;
  return (
    <div className="mt-6">
      <div className="gf-overline mb-2">Synopsis</div>
      <div
        className="text-sm leading-relaxed text-zinc-700 max-h-96 overflow-auto border border-zinc-200 p-4 bg-zinc-50"
        dangerouslySetInnerHTML={{ __html: safeDescriptionHtml }}
      />
    </div>
  );
}
